import styled from 'styled-components';

export const RenameOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 80;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(0, 0, 0, 0.7);
`;

export const RenameModalCard = styled.div`
  width: 100%;
  max-width: 448px;
  padding: 24px;
  border-radius: 12px;
  background: #161616;
  border: 1px solid #262626;

  h3 {
    margin: 0 0 4px;
    font-size: 18px;
    font-weight: 600;
    color: var(--white);
  }

  .subtitle {
    margin: 0 0 16px;
    font-size: 14px;
    line-height: 20px;
    color: #707070;
  }

  .actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 16px;

    button {
      padding: 8px 16px;
      border: 0;
      border-radius: 8px;
      font-size: 14px;
      cursor: pointer;
    }

    .cancel {
      background: transparent;
      color: #a0a0a0;

      &:hover {
        color: var(--white);
      }
    }

    .submit {
      background: var(--primary);
      color: var(--white);
      font-weight: 500;

      &:hover:not(:disabled) {
        opacity: 0.9;
      }

      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }
    }
  }
`;

/** Kept for leftover imports */
export const StyledRenameChatModal = RenameModalCard;
